import React from 'react'
import {
	BrowseButton,
	DropHint,
	DropIconWrap,
	DropLimits,
	DropTitle,
	DropZoneRoot,
} from '../ItineraryImportPage.styles'
import { MAX_IMPORT_FILE_SIZE_BYTES, MAX_IMPORT_FILES, MAX_IMPORT_PDF_PAGES } from '../utils'
import { CloudUpload } from './icons'

interface DropZoneProps {
	state: 'idle' | 'dragOver'
	onBrowse: () => void
}

const DropZone: React.FC<DropZoneProps> = ({ state, onBrowse }) => {
	const isDragOver = state === 'dragOver'
	return (
		<DropZoneRoot $state={state}>
			<DropIconWrap $active={isDragOver}>
				<CloudUpload size={isDragOver ? 30 : 24} />
			</DropIconWrap>
			<DropTitle $active={isDragOver}>
				{isDragOver ? (
					'Drop to add'
				) : (
					<>
						Drag files here or{' '}
						<BrowseButton type="button" onClick={onBrowse}>
							browse
						</BrowseButton>
					</>
				)}
			</DropTitle>
			<DropHint>
				PDFs, photos, screenshots — up to {MAX_IMPORT_FILES} files /{' '}
				{Math.round(MAX_IMPORT_FILE_SIZE_BYTES / (1024 * 1024))} MB / {MAX_IMPORT_PDF_PAGES} pages
				each.
			</DropHint>
			<DropLimits>We never share your files with the rest of your crew.</DropLimits>
		</DropZoneRoot>
	)
}

export default DropZone
